import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "confirmation-detail-row row py-4" }
const _hoisted_2 = { class: "confirmation-detail-label col-md-3" }
const _hoisted_3 = {
  key: 0,
  class: "confirmation-detail-divider col-md-12"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("strong", null, [
        _renderSlot(_ctx.$slots, "label")
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(['confirmation-detail-content', 'col-md-9', ..._ctx.contentClasses])
    }, [
      _renderSlot(_ctx.$slots, "content")
    ], 2),
    (!_ctx.bottom)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
      : _createCommentVNode("", true)
  ]))
}